import { GraphQLAuthMode } from "@aws-amplify/core/dist/esm/libraryUtils";

export const environment = {
  production: true,
  version: require('../../package.json').version,
  prefixVersion: 'L',
  name: 'LIVE',
  locale: 'en',
  homeRoot: 'dashboard',
  providers: {
    api: {
      url: 'https://api.thelogchain.com',
      auth: {
        type: 'Bearer',
      },
    },
  },
  LANGUAGE: {
    Default: 'en',
    Support: ['en', 'es', 'ja', 'zh'],
  },
  AWS_CONFIG: {
    Auth: {
      Cognito: {
        identityPoolId: 'ap-southeast-1:9a62efca-8842-4c83-b8a8-74c908d97280',
        region: 'ap-southeast-1',
        userPoolId: 'ap-southeast-1_qpq069qjV',
        userPoolClientId: '777863842j0ode9nbra1k9qpid',
      },
    },
    Storage: {
      S3: {
        bucket: 'logchain-live', //REQUIRED -  Amazon S3 bucket name
        region: 'ap-southeast-1', //OPTIONAL -  Amazon service region
        apiVersion: '2006-03-01',
      },
      customPrefix: {
        public: '', // we want to customize the prefix.
      },
    },
    API: {
      GraphQL: {
        endpoint:
          'https://42l2vexmrvhylpwxo4s4ls4h44.appsync-api.ap-southeast-1.amazonaws.com/graphql',
        region: 'ap-southeast-1',
        defaultAuthMode: 'userPool' as GraphQLAuthMode,
      },
    },
  },
  google_api_key: 'AIzaSyD1upPg36BJSXySxBF-0vOHjY0sUpS8t_E',
  firebase: {
    apiKey: 'AIzaSyD_Sa3uVPi8tplwkY8KXfNrbdqdPYd-n6Q',
    authDomain: 'lc-dev-be9e8.firebaseapp.com',
    projectId: 'lc-dev-be9e8',
    databaseURL: 'https://lc-dev-be9e8.firebaseio.com',
    storageBucket: 'lc-dev-be9e8.appspot.com',
    messagingSenderId: '493108013284',
    appId: '1:493108013284:web:8642dc75350a15e80164f1',
    measurementId: 'G-Z4DM68HGZ5',
  },
};

